export enum ReferenceTypes {
  Account = 'account',
  ClientAccount = 'clientAccount',
  User = 'user',
  Case = 'case',
  Document = 'document',
  DocumentsExport = 'documentsExport',
  DocumentBatch = 'documentBatch',
  Template = 'template',
  Workflow = 'workflow'
};

export enum Dimension {
  Service = 'service',
  Case = 'reference:case',
  CaseService = 'reference:case,service',
  SubscriptionServiceInvoice = 'subscription,service,invoice'
};
